// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 335 ? "f71da141" : chunkId) + "." + {"35":"02bf347daa4d7f97","335":"dbf62fb5cf84a176","838":"ef77cc8ed53f9f0a"}[chunkId] + ".js";
};